import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';

class AsrApiKeys extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAsrApiKeyDataApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];
        this.state = {
            data: [{
                id: '',
                apiType: '',
                key: '',
                secret: '',
                label: '',
                enabled: false
            }],
            editedapiType: '-1',
            pageNum: null,
            disabled: false,
            editedId: '-1',
            viewedId: '--1',
            editImageSrc: './assets/images/edit2.png',
            contentEditable: "false",
            showStore: false,
            hideDeletePopup: false,
            deleteRow: false,
        }
        this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.blindEyeSrc = "assets/images/blindEye.png";
        this.openEyeSrc = "assets/images/eye.png";
        this.apitypeVar = [];
    }
    componentDidMount() {
        setTimeout(() => {
            this.fetchAsrApiKeyDataApi();
        }, 300);
        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.state.disabled = false;
            thisController.projectId = event.projectId;
            thisController.fetchAsrApiKeyDataApi(event.projectId);
        });
    }
    addAsrApiKeyData = (data) => {
        var apiController = this;
        if (apiController.state.pageNum != 0) {
            apiController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            apiType: ''
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    notifyEmptyField() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill label field</b>, {
            position: "top-center"
        });

    }
    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API key Added Successfully</b>, {
            position: "top-center",

        });
    }
    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API key updated Successfully</b>, {
            position: "top-center",

        });
    }

    saveAsrApiKeyDataApi = (props, e) => {
        var thisController = this;
        props.original.label = document.getElementById("label" + props.index).innerText.trim();
        props.original.enabled = document.getElementById("enableApiKey" + props.index).checked;
        if (props.original.label == "") {
            thisController.notifyEmptyField();
        } else {
            $.ajax({
                url: "/api/api-key",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: {
                    projectId: localStorage.getItem("currentProjectId"),
                    apiType: "ASR_API",
                    label: props.original.label,
                    enabled: props.original.enabled
                },

                success: function (res) {
                    if (res.success === true) {
                        thisController.notifyAdded();
                        thisController.fetchAsrApiKeyDataApi();
                        thisController.state.disabled = false;
                    } else {
                        thisController.notifyFailedToAdd(res.result);
                        thisController.state.disabled = false;
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }

            });
        }
    }
    updateAsrApiKeyDataApi = (props) => {
        var thisController = this;
        props.original.label = document.getElementById("label" + props.index).innerText.trim();
        props.original.enabled = document.getElementById("enableApiKey" + props.index).checked;
        if (props.original.label == "") {
            thisController.notifyEmptyField();
        } else {
            $.ajax({
                url: "/api/api-key-update",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: {
                    id: props.original.id,
                    projectId: localStorage.getItem("currentProjectId"),
                    apiType: "ASR_API",
                    label: props.original.label,
                    enabled: props.original.enabled
                },

                success: function (res) {
                    if (res.success === true) {
                        thisController.notifyUpdated();
                        thisController.fetchAsrApiKeyDataApi();
                        thisController.state.editedapiType = '-1';
                        thisController.state.disabled = false;
                    } else {
                        thisController.notifyFailedToAdd(res.result);
                        thisController.state.editedapiType = '-1';
                        thisController.state.disabled = false;
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }

            });
        }
    }



    notifyFailedToAdd(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }
    notifyFailedToLoadData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    // loadApiTypes = () => {
    //     var fetchController = this;
    //     var responseData = []
    //     $.ajax(
    //         {
    //             url: "/api/api-types",
    //             async: false,
    //             method: 'GET',
    //             headers: {
    //                 'Authorization': "Bearer " + localStorage.getItem("access_token")
    //             },
    //             success: function (res) {
    //                 if (res.success === true) {
    //                     responseData = res.result;
    //                     var numberOfApiTypes = responseData.length;
    //                     fetchController.apitypeVar = [];
    //                     for (var i = 0; i < numberOfApiTypes; i++) {
    //                         fetchController.apitypeVar.push({
    //                             "value": responseData[i]["value"],
    //                             "key": responseData[i]["key"]
    //                         });
    //                     }
    //                     var ele3 = document.getElementById("apitype");
    //                     if (ele3 != "") {
    //                         if (ele3 != null) {
    //                             if (ele3.value != "Select Api Type") {
    //                                 ele3.innerHTML = "";
    //                             }

    notifyFailedToLoad(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            {response}</b>, {
            position: "top-center"
        });
        this.fetchAsrApiKeyDataApi();
    }
    fetchAsrApiKeyDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var thisController = this;
        var apis = [];
        $.ajax({
            url: "/api/api-key/api-type",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                apiType: "ASR_API"

            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },

            success: function (res) {
                if (res.success === true) {
                    var apiData = res.result;
                    for (var i = 0; i < apiData.length; i++) {
                        if (apiData[i].apiType == "ASR_API") {
                            apis.push(apiData[i]);
                        }
                    }

                    thisController.setState({
                        data: apiData,
                        disabled: false,
                    })
                }
                else {
                    thisController.notifyFailedToLoadData(res.result)
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    deleteAsrApiKeyDataApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteRowViewController.splice(id, 1);
            deleteApiViewController.fetchAsrApiKeyDataApi();
            deleteApiViewController.notifyDeleted();
            deleteApiViewController.state.disabled = false;
        }
        $.ajax({
            url: "/api/api-key/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {

                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteRowViewController.splice(id, 1);
                    deleteApiViewController.fetchAsrApiKeyDataApi();
                    deleteApiViewController.notifyDeleted();
                    deleteApiViewController.state.disabled = false;

                } else {
                    deleteApiViewController.notifyFailToDelete(res.result);
                    deleteApiViewController.state.disabled = false;
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });

    }
    notifyDeleted() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;API key Deleted Successfully</b>, {
            position: "top-center"
        });
    }
    notifyFailToDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }
    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please fill label field</b>, {
            position: "top-center"
        });
    }
    notifyAutoGenerated = () => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;API key and secret will be generate automatically</b>, {
            position: "top-center"
        });
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {

        this.state.editedapiType = id;
        var stateObj = this.state;
        this.setState(stateObj);

    }
    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedapiType = id;
        this.fetchAsrApiKeyDataApi()
        this.setState({ disabled: false })

    }
    viewClickedCell(props, e) {
        if (this.state.viewedId == props.original.id) {
            this.closeClickedCell(props, e)
            return
        }
        this.state.viewedId = props.original.id;
        props.original.secret = document.getElementById("secret" + props.index).value;
        props.original.key = document.getElementById("key" + props.index).innerText;
        props.original.label = document.getElementById("label" + props.index).innerText;
        props.original.enabled = document.getElementById("enableApiKey" + props.index).checked;

        console.info('viewedId set to ' + props.original.id);
        this.setState(this.state);
    }
    closeClickedCell(props, e) {
        this.state.viewedId = '--1';
        this.setState(this.state);
    }
    render() {
        this.columns = [
            {
                Header: 'Id',
                accessor: 'id',
                show: false,
                Cell: props => (
                    <div name="id" id={"id" + props.index}>{props.original.id}
                    </div>)
            },
            {
                Header: <b>Label</b>,
                accessor: 'label',
                sortable: false,
                Cell: props => (<div className="input"
                    Align="left"
                    style={{ width: '98%', padding: '8px', border: (props.original.id == undefined || props.original.id == this.state.editedapiType) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == undefined) ? '2px' : 'none', paddingLeft: '2px' }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedapiType) ? "plaintext-only" : false}
                    suppressContentEditableWarning
                    type="text" id={"label" + props.index}>{props.original.label}</div>
                )
            },
            {
                Header: <b>Key</b>,
                accessor: 'key',
                sortable: false,
                Cell: props => (<div onClick={(e) => { ((props.original.id == undefined) || props.original.id == this.state.editedapiType) ? this.notifyAutoGenerated() : "" }}
                    Align="left" className="textarea"
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"key" + props.index}>{props.original.key}</div>
                )
            },

            {
                Header: <b>Secret</b>,
                accessor: 'secret',
                sortable: false,
                Cell: props => (<div>
                    <input
                        type={props.original.id == this.state.viewedId ? "text" : "password"}
                        style={{
                            paddingLeft: '2px', width: '98%', border: 'none'
                        }}
                        id={"secret" + props.index}
                        defaultValue={props.original.secret}
                        disabled={true}
                    ></input>

                    <img className="img-responsive"
                        style={{
                            display: '-webkit-inline-box', position: 'relative',
                            marginLeft: '-34px',
                            marginTop: '2px', width: '26px', textAlign: 'right',
                            backgroundColor: '#282a65', borderRadius: '5px',
                            padding: '2px'
                        }}
                        src={
                            (props.original.id == this.state.viewedId)
                                ?
                                this.blindEyeSrc
                                :
                                this.openEyeSrc}
                        onClick={(e) => {
                            this.viewClickedCell(props, e)

                        }}
                    />
                </div>)
            },
            {
                Header: <b>Enable API Key</b>,
                accessor: 'enableApiKey',
                sortable: false,
                width: 110,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch">
                                <input type="checkbox" id={"enableApiKey" + props.index}
                                    defaultChecked={props.original.enabled}
                                    disabled={(props.original.id == undefined) ? false : props.original.id != this.state.editedapiType} />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }

            },
            // {
            //     Header: <b>Api Type</b>,
            //     textAlign: 'screenLeft',
            //     accessor: 'apiType',
            //     headerStyle: { textAlign: 'center' },
            //     Cell: props => {
            //         return (
            //             <div className="container-fluid" style={{ textAlign: "center", marginLeft: '40px' }}>
            //                 <select className="input-group form-control select2 "
            //                     tabIndex={-1} aria-hidden="true"
            //                     name="apitype"
            //                     style={{ textAlign: "center", background: 'white', border: 'none', width: '60%' }}
            //                     id={"apitype" + props.index}
            //                     disabled={(props.original.id != undefined) ? props.original.id != this.state.editedapiType : false} >{props.original.key}
            //                     {this.apitypeVar.map((apiType) => <option key={apiType}
            //                         value={apiType.value} selected={props.original.apiType == apiType.value}>{apiType.key}</option>)}
            //                 </select>
            /* <select className="input-group form-control select2 "
                tabIndex={-1} aria-hidden="true"
                name="role"
                style={{ textAlign: "center", background: 'white', border: 'none', width: '60%' }}
                id={"role" + props.index}
                disabled={(props.original.id != "") ? props.original.id != this.state.editedId : false} >{props.original.userEmail}
                {this.roleVar.map((role) => <option key={role}
                    value={role.code} selected={props.original.role == role.code}>{role.name}</option>)}
            </select> */
            //             </div>
            //         )
            //     },
            // },
            {
                Header: <b>Action</b>,
                accessor: 'action',
                sortable: false,
                width: 100,
                Cell: props => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px' }} >
                            <img className="img-responsive"
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedapiType) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(props.original.id == undefined) ? this.saveImageSrc : ((props.original.id != this.state.editedapiType) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == undefined) ? this.saveAsrApiKeyDataApi(props, e) : (props.original.id == this.state.editedapiType) ?
                                        this.updateAsrApiKeyDataApi(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>
                        <button style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            marginTop: '-9px', marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchAsrApiKeyDataApi() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index,
                                        propsId: props.original.id
                                    })
                                } />
                        </button>
                    </div>
                ),
            },
        ]
        return (
            <div style={{ background: "#F9F9FB" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />


                {/* for reactTable */}

                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="wrapper">
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | API keys </title>
                    {/* IonIcons */}
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                    <div className="container-fluid" >
                        < ToastContainer className="Toast-at-center" />
                        <div className="row">
                            <div className="col-sm-5">
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>API Keys</h6>
                            </div>
                            <div className="col-sm-7" Align="right">
                                <button className="btn action-button"
                                    title="Add"
                                    id="addApiType"
                                    onClick={this.state.disabled ? this.notifyEmptyFields : this.addAsrApiKeyData}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData} type="button" title="Refresh" className="btn action-button">
                                    <img src="./assets/images/refresh_white_24dp.png"></img></button>
                            </div>
                            <div className="col-lg-12 ">

                                <div className="card">

                                    <div >
                                        <ReactTable id='reactTable'
                                            data={this.state.data}
                                            columns={this.columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                        />
                                        {/*Dialog Component For Deletion Confirmation*/}
                                        <DialogComponent width='400px' animationSettings={this.settings}
                                            header='ASR API Key' showCloseIcon={true} buttons={this.buttons}
                                            ref={dialog => this.dialogInstance = dialog}
                                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                content="" />&nbsp;Do you want to delete the API key?<br />
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


}

export default AsrApiKeys;


// WEBPACK FOOTER //
// ./src/asrUi/AsrApiKeys.js